import { SceneItem } from 'types/Scene';

export const DEFAULT_IMAGE_DURATION = 5000;
export const MAX_IMAGE_DURATION = 15000;
export const PREPROCESSING_POLL_DELAY = 3000;
export const DURATION_REQUIRED_FOR_TRANSITION = 1000;
export const MIN_SCENE_DURATION = 1000;

export const EMPTY_TRANSITION: SceneItem['transition'] = { id: null, duration: 0 };
